import React from 'react';

const NewsItem = ({ title, main_text, content, news_text, date }) => {
  const text = main_text || content || news_text || '';
  const preview = text.length > 150 ? text.substring(0, 150) + '...' : text;
  
  // Format date
  const formattedDate = date ? new Date(date).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }) : '';
  
  return (
    <div className="news-item">
      {date && <div className="news-item-date">{formattedDate}</div>}
      <h4>{title || 'Untitled'}</h4>
      <p>{preview}</p>
      <div className="news-item-footer">
        <span className="read-more-link">Read more →</span>
      </div>
    </div>
  );
}

export default NewsItem;
